<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-menu-button></ion-menu-button>
                </ion-buttons>
                <ion-title>Home</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <!-- <Reservations /> -->
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent ({
    name: 'helpdesk',
    data() {
        return {

        }
    },
})
</script>